<script setup>
import followupIcon from 'dashboard/assets/images/gg-followup.svg?url';
import Button from 'dashboard/components-next/button/Button.vue';
import { useGgFollowup } from 'dashboard/composables/useGgFollowup';

const props = defineProps({
  conversationId: { type: Number, required: true },
  menu: { type: Boolean, default: false },
});
const emit = defineEmits(['selected']);
const { enabled, open } = useGgFollowup();
const launch = () => {
  open(props.conversationId);
  emit('selected');
};
</script>

<template>
  <Button
    v-show="enabled"
    v-tooltip.top="{
      content: menu ? '' : $t('GG_FOLLOWUP.TOOLTIP'),
      popperClass: 'whitespace-pre-line text-center',
    }"
    :label="menu ? $t('GG_FOLLOWUP.BUTTON') : ''"
    :aria-label="
      menu
        ? $t('GG_FOLLOWUP.BUTTON')
        : $t('GG_FOLLOWUP.TOOLTIP').replace('\n', ' ')
    "
    :class="menu ? 'w-full justify-start' : 'shrink-0'"
    color="slate"
    :variant="menu ? 'ghost' : 'faded'"
    size="sm"
    type="button"
    @click.stop="launch"
  >
    <template #icon>
      <img
        :src="followupIcon"
        class="w-5 h-5 shrink-0 guandalini:dark:rounded-sm guandalini:dark:bg-guandalini-warm"
        alt=""
        draggable="false"
      />
    </template>
  </Button>
</template>
